// extracted by mini-css-extract-plugin
export default {"themeCard":"theme-details_themeCard__PalEA"};